import StaffDto from "../../dto/StaffDto";

export default class StaffUpdateRequest {
  staffs = [];
  constructor(datas) {
    datas.forEach(data => {
      const staff = new StaffDto(data);
      this.staffs.push(staff);
    });
  }
}
